var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.62 147.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ca5ad;}.cls-2{fill:#505050;stroke:#505050;stroke-miterlimit:10;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.19,31.39v-9.8H95.27A19.88,19.88,0,0,0,93,16.15l4.91-4.91L91,4.31l-4.89,4.9a20,20,0,0,0-5.43-2.27V0h-9.8V6.92a20.19,20.19,0,0,0-5.44,2.24L60.54,4.25l-6.93,6.93,4.89,4.9a20,20,0,0,0-2.26,5.43H49.3v9.8h6.92a19.88,19.88,0,0,0,2.24,5.44l-4.91,4.91,6.93,6.93,4.89-4.89A20.17,20.17,0,0,0,70.8,46V52.9h9.8V46A19.88,19.88,0,0,0,86,43.73L91,48.65l6.93-6.93L93,36.82a19.88,19.88,0,0,0,2.27-5.43ZM75.74,35.26a8.82,8.82,0,1,1,8.82-8.81A8.81,8.81,0,0,1,75.74,35.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.81,89.56l4-11.46-8.1-2.79a24.45,24.45,0,0,0-.43-7.26L65,64.29l-5.31-10.9L52,57.14a24.87,24.87,0,0,0-5.43-4.83l2.79-8.12L37.86,40.24l-2.79,8.09a24.78,24.78,0,0,0-7.26.43L24.05,41l-10.9,5.31L16.9,54a24.66,24.66,0,0,0-4.83,5.44L4,56.68,0,68.14l8.09,2.79a24.8,24.8,0,0,0,.43,7.26L.8,82l5.31,10.9,7.69-3.76a24.71,24.71,0,0,0,5.44,4.84l-2.8,8.12,11.46,4,2.79-8.1A24.8,24.8,0,0,0,38,97.48l3.76,7.72L52.6,99.89l-3.75-7.7a24.66,24.66,0,0,0,4.84-5.43ZM29.32,83.43a10.91,10.91,0,1,1,13.86-6.76A10.91,10.91,0,0,1,29.32,83.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.53,130.41l-.45-.46L141.17,140.7l.27.26,2.84,2.89c1.83,1.86,5.76,1,8.77-2s4-6.88,2.14-8.73l-2.66-2.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "149.45 127.33 138.54 138.07 141.17 140.7 152.08 129.95 151.78 129.64 151.77 129.64 149.45 127.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.52,37.32a42.2,42.2,0,1,0,22.78,77.51l23.24,23.24,10.91-10.74-23.09-23.09A42.14,42.14,0,0,0,92.52,37.32Zm0,71.87a29.67,29.67,0,1,1,29.9-29.45A29.66,29.66,0,0,1,92.56,109.19Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.700a7e53f5eee42497f84e7d1f7d826a.svg";
export { ForwardRef as ReactComponent };